import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Fieldset } from 'primereact/fieldset'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Checkbox } from 'primereact/checkbox'
import { FaTrash } from 'react-icons/fa'

import {
  Btn,
  CustomCalendar,
  CustomDropdown,
  CustomDataTableHeader,
  CustomPanel,
  InputText,
  InputTime,
  PageHeader,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import { getTransportadoras } from '../../../../services/api/https/registration/transportadora.http'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { gerarArquivoOcorren } from './ocorren-generator'
import { CODIGOS_OCORRENCIA, CODIGOS_OBSERVACAO } from './ocorren-constants'

function getCurrentTimeString() {
  const now = new Date()
  return `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`
}

function GerarOcorren({ history, dispatch, selectedTp }) {
  // State - entregas vindas da tela anterior
  const [entregas, setEntregas] = useState([])
  const [selectedEntregas, setSelectedEntregas] = useState([])
  const [globalFilter, setGlobalFilter] = useState('')
  const [empresaNome, setEmpresaNome] = useState('')

  // State - cabeçalho do arquivo
  const [destinatario, setDestinatario] = useState('')
  const [dataCabecalho, setDataCabecalho] = useState(new Date())
  const [horaCabecalho, setHoraCabecalho] = useState(getCurrentTimeString())
  const [identificadorDocumento, setIdentificadorDocumento] = useState('')
  const [transportadoraOptions, setTransportadoraOptions] = useState([])
  const [selectedTransportadora, setSelectedTransportadora] = useState(null)

  // State - fieldset ocorrências
  const [codigoOcorrencia, setCodigoOcorrencia] = useState(null)
  const [dataOcorrencia, setDataOcorrencia] = useState(new Date())
  const [horaOcorrencia, setHoraOcorrencia] = useState(getCurrentTimeString())
  const [codigoObservacao, setCodigoObservacao] = useState(null)
  const [infoAdicional, setInfoAdicional] = useState('')
  const [mostrarTextoComplementar, setMostrarTextoComplementar] = useState(false)
  const [textoLivre1, setTextoLivre1] = useState('')
  const [textoLivre2, setTextoLivre2] = useState('')
  const [textoLivre3, setTextoLivre3] = useState('')

  useEffect(() => {
    if (!history.location.state || !history.location.state.entregas) {
      dispatch(showMessageBox(null, 'Nenhuma entrega foi encontrada. Volte e tente novamente.'))
      return
    }

    const entregasRecebidas = history.location.state.entregas.map((e, idx) => ({
      ...e,
      _ocorren_id: idx,
      _codigo_ocorrencia: null,
      _data_ocorrencia: null,
      _hora_ocorrencia: '',
      _codigo_observacao: null,
      _info_adicional: '',
      _texto_livre_1: '',
      _texto_livre_2: '',
      _texto_livre_3: '',
    }))
    setEntregas(entregasRecebidas)
    if (history.location.state.empresaNome) {
      setEmpresaNome(history.location.state.empresaNome)
    }
  }, [])

  useEffect(() => {
    if (selectedTp) {
      fetchTransportadoras()
    }
  }, [selectedTp])

  const fetchTransportadoras = async () => {
    try {
      const data = await getTransportadoras(selectedTp)
      setTransportadoraOptions(
        data.map(t => ({
          label: t.nome,
          value: t,
        })),
      )
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const adicionarOcorrenciaAsSelecionadas = () => {
    if (selectedEntregas.length === 0) {
      dispatch(showMessageBox(null, 'Selecione pelo menos uma entrega'))
      return
    }
    if (codigoOcorrencia === null || codigoOcorrencia === undefined) {
      dispatch(showMessageBox(null, 'Selecione o Código de Ocorrência'))
      return
    }
    if (!dataOcorrencia) {
      dispatch(showMessageBox(null, 'Informe a Data da Ocorrência'))
      return
    }
    if (!horaOcorrencia || horaOcorrencia.includes('_')) {
      dispatch(showMessageBox(null, 'Informe a Hora da Ocorrência'))
      return
    }
    if (codigoObservacao === null || codigoObservacao === undefined) {
      dispatch(showMessageBox(null, 'Selecione o Código de Observação de Ocorrência'))
      return
    }

    // PrimeReact Dropdown sem optionValue retorna o objeto inteiro; extrair só o .value
    const codOcorr =
      codigoOcorrencia && typeof codigoOcorrencia === 'object'
        ? codigoOcorrencia.value
        : codigoOcorrencia
    const codObs =
      codigoObservacao && typeof codigoObservacao === 'object'
        ? codigoObservacao.value
        : codigoObservacao

    const selectedIds = selectedEntregas.map(e => e._ocorren_id)
    setEntregas(prev =>
      prev.map(entrega => {
        if (selectedIds.includes(entrega._ocorren_id)) {
          return {
            ...entrega,
            _codigo_ocorrencia: codOcorr,
            _data_ocorrencia: dataOcorrencia,
            _hora_ocorrencia: horaOcorrencia,
            _codigo_observacao: codObs,
            _info_adicional: infoAdicional,
            _texto_livre_1: textoLivre1,
            _texto_livre_2: textoLivre2,
            _texto_livre_3: textoLivre3,
          }
        }
        return entrega
      }),
    )
    setSelectedEntregas([])
  }

  const removerEntrega = entrega => {
    setEntregas(prev => prev.filter(e => e._ocorren_id !== entrega._ocorren_id))
    setSelectedEntregas(prev => prev.filter(e => e._ocorren_id !== entrega._ocorren_id))
  }

  const validarEGerarArquivo = () => {
    // Validar campos do cabeçalho
    if (!destinatario.trim()) {
      dispatch(showMessageBox(null, 'Preencha o campo Destinatário'))
      return
    }
    if (!dataCabecalho) {
      dispatch(showMessageBox(null, 'Preencha a Data do cabeçalho'))
      return
    }
    if (!horaCabecalho || horaCabecalho.includes('_')) {
      dispatch(showMessageBox(null, 'Preencha a Hora do cabeçalho'))
      return
    }
    if (!identificadorDocumento.trim()) {
      dispatch(showMessageBox(null, 'Preencha o Identificador do Documento'))
      return
    }
    if (!selectedTransportadora) {
      dispatch(showMessageBox(null, 'Selecione a Transportadora'))
      return
    }

    if (entregas.length === 0) {
      dispatch(showMessageBox(null, 'Não existem entregas na lista'))
      return
    }

    // Validar que todas as entregas tenham os campos obrigatórios preenchidos
    const entregasIncompletas = entregas.filter(
      e =>
        e._codigo_ocorrencia === null ||
        e._codigo_ocorrencia === undefined ||
        !e._data_ocorrencia ||
        !e._hora_ocorrencia ||
        e._codigo_observacao === null ||
        e._codigo_observacao === undefined,
    )

    if (entregasIncompletas.length > 0) {
      dispatch(
        showMessageBox(
          null,
          `Existem ${entregasIncompletas.length} entrega(s) sem todos os campos obrigatórios preenchidos (Código de Ocorrência, Data/Hora, Código de Observação). Utilize os campos acima para associar as ocorrências.`,
        ),
      )
      return
    }

    try {
      gerarArquivoOcorren({
        empresaNome,
        destinatario,
        dataCabecalho,
        horaCabecalho,
        identificadorDocumento,
        transportadora: selectedTransportadora,
        entregas,
      })
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  const getCodigoOcorrenciaLabel = codigo => {
    if (codigo === null || codigo === undefined) return ''
    const found = CODIGOS_OCORRENCIA.find(c => c.value === codigo)
    return found ? found.label : String(codigo)
  }

  const getCodigoObservacaoLabel = codigo => {
    if (codigo === null || codigo === undefined) return ''
    const found = CODIGOS_OBSERVACAO.find(c => c.value === codigo)
    return found ? found.label : String(codigo)
  }

  const formatDateBr = date => {
    if (!date) return ''
    const d = new Date(date)
    return d.toLocaleDateString('pt-BR')
  }

  return (
    <React.Fragment>
      <PageHeader>
        Gerar arquivo PROCEDA -&nbsp;<strong>Padrão OCORREN</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          {/* Campos do Cabeçalho */}
          <div className="p-grid">
            <div className="p-col-3">
              <InputText
                label="Destinatário (max 35 caracteres)"
                value={destinatario}
                onChange={val => setDestinatario(val.slice(0, 35))}
              />
            </div>
            <div className="p-col-2" style={{ marginTop: 12 }}>
              <CustomCalendar label="Data" value={dataCabecalho} onChange={setDataCabecalho} />
            </div>
            <div className="p-col-1" style={{ marginTop: 2 }}>
              <InputTime
                label="Hora"
                value={horaCabecalho}
                onChange={setHoraCabecalho}
              />
            </div>
            <div className="p-col-2">
              <InputText
                label="Ident. Documento (max 5)"
                value={identificadorDocumento}
                onChange={val => setIdentificadorDocumento(val.slice(0, 5))}
              />
            </div>
            <div className="p-col-4" style={{ marginTop: 10 }}>
              <CustomDropdown
                label="Transportadora"
                options={transportadoraOptions}
                value={selectedTransportadora}
                onChange={setSelectedTransportadora}
                optionLabel="label"
                filter={true}
                placeholder="Selecione a transportadora"
              />
            </div>
          </div>

          {/* Fieldset - Ocorrências Por Entrega */}
          <div className="p-col-12" style={{ marginTop: 20 }}>
            <Fieldset legend="Ocorrências Por Entrega" toggleable={false}>
              <div className="p-grid">
                <div className="p-col-4">
                  <CustomDropdown
                    label="Código de Ocorrência"
                    options={CODIGOS_OCORRENCIA}
                    value={codigoOcorrencia}
                    onChange={setCodigoOcorrencia}
                    optionLabel="label"
                    filter={true}
                    placeholder="Selecione"
                  />
                </div>
                <div className="p-col-2">
                  <CustomCalendar
                    label="Data Ocorrência"
                    value={dataOcorrencia}
                    onChange={setDataOcorrencia}
                  />
                </div>
                <div className="p-col-1" style={{ marginTop: -10 }}>
                  <InputTime
                    label="Hora"
                    value={horaOcorrencia}
                    onChange={setHoraOcorrencia}
                  />
                </div>
                <div className="p-col-3" style={{ marginTop: -1 }}>
                  <CustomDropdown
                    label="Cód. Observação de Ocorrência"
                    options={CODIGOS_OBSERVACAO}
                    value={codigoObservacao}
                    onChange={setCodigoObservacao}
                    optionLabel="label"
                    placeholder="Selecione"
                  />
                </div>
              </div>

              <div className="p-grid" style={{ marginTop: 10 }}>
                <div className="p-col-6">
                  <InputText
                    label="Info Adicional (Opcional - max 203 caracteres)"
                    value={infoAdicional}
                    onChange={val => setInfoAdicional(val.slice(0, 203))}
                  />
                </div>
              </div>

              <div className="p-grid" style={{ marginTop: 10 }}>
                <div className="p-col-12">
                  <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                    <Checkbox
                      checked={mostrarTextoComplementar}
                      onChange={e => setMostrarTextoComplementar(e.checked)}
                      inputId="cbTextoComplementar"
                    />
                    <label htmlFor="cbTextoComplementar" style={{ marginLeft: 8, cursor: 'pointer' }}>
                      Adicionar texto complementar de ocorrência
                    </label>
                  </div>
                </div>
              </div>

              {mostrarTextoComplementar && (
                <div className="p-grid" style={{ marginTop: 10 }}>
                  <div className="p-col-4">
                    <InputText
                      label="Texto Livre 1 (max 70 caracteres)"
                      value={textoLivre1}
                      onChange={val => setTextoLivre1(val.slice(0, 70))}
                    />
                  </div>
                  <div className="p-col-4">
                    <InputText
                      label="Texto Livre 2 (max 70 caracteres)"
                      value={textoLivre2}
                      onChange={val => setTextoLivre2(val.slice(0, 70))}
                    />
                  </div>
                  <div className="p-col-4">
                    <InputText
                      label="Texto Livre 3 (max 70 caracteres)"
                      value={textoLivre3}
                      onChange={val => setTextoLivre3(val.slice(0, 70))}
                    />
                  </div>
                </div>
              )}

              <div className="p-grid" style={{ marginTop: 15 }}>
                <div className="p-col-6">
                  <Btn onClick={adicionarOcorrenciaAsSelecionadas}>
                    Adicionar à Entregas Selecionadas
                  </Btn>
                </div>
                <div className="p-col-6" style={{ textAlign: 'right' }}>
                  <Btn onClick={validarEGerarArquivo}>Gerar Arquivo OCORREN</Btn>
                </div>
              </div>

              {/* Tabela de Entregas */}
              <div style={{ marginTop: 0 }}>
                <DataTable
                  value={entregas}
                  selection={selectedEntregas}
                  onSelectionChange={e => setSelectedEntregas(e.value)}
                  emptyMessage="Nenhuma entrega"
                  header={
                    <CustomDataTableHeader value={globalFilter} onChange={setGlobalFilter} />
                  }
                  globalFilter={globalFilter}
                  rows={20}
                  paginator={true}
                  className="auto-layout"
                  dataKey="_ocorren_id"
                >
                  <Column
                    selectionMode="multiple"
                    style={tableCellCentered(50)}
                  />
                  <Column
                    field="identifier"
                    header="Identificador"
                    style={tableCellCentered(120)}
                  />
                  <Column
                    header="Código de Ocorrência"
                    body={e => getCodigoOcorrenciaLabel(e._codigo_ocorrencia)}
                    style={tableCellCentered(200)}
                  />
                  <Column
                    header="Data e Hora"
                    body={e =>
                      e._data_ocorrencia
                        ? `${formatDateBr(e._data_ocorrencia)} ${e._hora_ocorrencia || ''}`
                        : ''
                    }
                    style={tableCellCentered(150)}
                  />
                  <Column
                    header="Cód. Obs. Ocorrência"
                    body={e => getCodigoObservacaoLabel(e._codigo_observacao)}
                    style={tableCellCentered(180)}
                  />
                  <Column
                    header="Info Adicional"
                    body={e => e._info_adicional || ''}
                    style={tableCellCentered(200)}
                  />
                  <Column
                    header="Campo Livre"
                    body={e => {
                      const textos = [e._texto_livre_1, e._texto_livre_2, e._texto_livre_3].filter(
                        t => t,
                      )
                      return textos.length > 0 ? textos.join(' | ') : ''
                    }}
                    style={tableCellCentered(250)}
                  />
                  <Column
                    header=""
                    style={tableCellCentered(50)}
                    body={entrega => (
                      <FaTrash
                        style={{ cursor: 'pointer' }}
                        color="red"
                        onClick={() => removerEntrega(entrega)}
                      />
                    )}
                    bodyStyle={tableCellCentered()}
                  />
                </DataTable>
              </div>
            </Fieldset>
          </div>
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({
  selectedTp,
})

export default connect(mapStateToProps)(withRouter(GerarOcorren))
